<template>
  <div id="Schedule">
    <b-container fluid>
      <b-row class="mb-1 text-left">
        <b-col>
          <h1 class="labelBold">{{ this.$t(`bookingTransport.Schedule.title`) }} </h1>
        </b-col>
      </b-row>
      <br/>
      <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12">
      </b-row>
      <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12">
        <b-col sm="12" lg="12">
          <v-server-table :columns="table_options.columns" :options="table_options.options" ref="ScheduleTable" id="ScheduleTable">
            <template #start_date="props">{{props.row.start_date | formatDateOnly(appLang)}}</template>
            <template #end_date="props">{{props.row.end_date | formatDateOnly(appLang)}}</template>
            <template #enabled="props">{{ translateStatus(props.row.enabled) }}</template>
            <template #start_time="props">{{ timeOk(props.row.start_time) }}</template>
            <template #end_time="props">{{ timeOk(props.row.end_time) }}</template>

            <template v-slot:actions="props">
              <center>
                <i style='font-size:24px' class='fas btn-outline-secondary' @click="Modify(props.row.id,props.row.enabled,props.row.shift_name,props.row.start_date,props.row.end_date,props.row.start_time,props.row.end_time, props.row.type)">&#xf044;</i>
              </center>
            </template>
            <button
              class="btn-confirm btn-outline-secondary"
              slot="beforeLimit"
              type="primary"
              @click="showModal">
              {{ $t("bookingTransport.Schedule.add") }}
            </button>
            <div slot="filter__start_date">
              <date-picker  id="start_date" name="start_date" @change="filterDate(start_date_filter)"  v-model="start_date_filter"
                            placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
              </date-picker>
            </div>
            <div slot="filter__end_date">
              <date-picker  id="end_date" name="end_date" @change="filterDateEnd(end_date_filter)"  v-model="end_date_filter"
                            placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
              </date-picker>
            </div>
            <div slot="filter__enabled">
              <select class="form-control" name="enabled" id ="enabled" v-model="selected"  @change="filterStatus(selected)">
                <option v-for="option in options"
                        v-bind:key="option.id"
                        v-bind:value="option.id">
                  {{option.name }}
                </option>
              </select>
            </div>


          </v-server-table>
        </b-col>
      </b-row>
    </b-container>

    <b-modal size="lg" centered ref="my-info"  scrollable :title="$t('users.search.infoCsv')" tabindex="-1" >
      <div v-if="appLang =='es'">
        <p>
          Archivo en formato .csv
          <br/>
          Id_Ruta,	Id_Parada,	Descripción_Parada,	Número_Parada,	Coordenadas
          <br/>
        </p>
      </div>
      <div v-if="appLang =='en'">
        File in .csv format
        <br/>
        Id_Ruta,	Id_Parada,	Descripción_Parada,	Número_Parada,	Coordenadas
        <br/>
      </div>

      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="DowloadLayout()"
          >
            {{ $t("bookingTransport.download") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="lg" centered ref="my-error" hide-footer scrollable :title="$t('bookingTransport.errorUpload')" tabindex="-1" >
      <div>
             <textarea v-model="error" class="form-control" rows="15">
             </textarea>
      </div>

      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="DowloadLayout()">
            {{ $t("bookingTransport.download") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" centered ref="my-edit" no-close-on-backdrop :title="$t('bookingTransport.edit')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100">

          <div v-if="edit">
            <h3>
              <p class="labelBold float-left">{{$t('bookingTransport.Schedule.edit')}}</p>
            </h3>

          </div>
          <div v-else>
            <h3>
              <p class="labelBold float-left">{{$t('bookingTransport.Schedule.new')}}</p>
            </h3>
          </div>

        </div>
      </template>
      <b-container class="bv-example-row">

        <!-- <div class="row">
              <div class="col-1">
                   <label for="chkpublic">{{$t('uploadsAndLinks.uploadFiles.public')}}</label>
                   <input type="radio" id="chkpublic" value="true" v-model="picked">
                   <label for="chkprivate">{{$t('uploadsAndLinks.uploadFiles.private')}}</label>
                   <input type="radio" id="chkprivate" value="false" v-model="picked">
              </div>
              <div class="col-11">
              </div>
        </div> -->

        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">


          <b-col sm="1">
            <div v-if="edit">
              <label class="labelBold">{{ $t("bookingTransport.Schedule.tableSchedule.headings.id") }}</label>
              <input type="text" v-model="id" disabled />
            </div>
            <div v-else>
            </div>
          </b-col>
          <b-col sm="2">
            <!-- <label for="chkpublic">{{$t('uploadsAndLinks.uploadFiles.public')}}</label>
            <input type="radio" id="chkpublic" value="true" v-model="picked">
            <label for="chkprivate">{{$t('uploadsAndLinks.uploadFiles.private')}}</label>
            <input type="radio" id="chkprivate" value="false" v-model="picked"> -->
            <label for="statusSchedule" class="labelBold">
              {{ $t("bookingTransport.Schedule.tableSchedule.headings.enabled") }}
            </label>
            <br/>
            <select class="form-control mt-2" id ="statusSchedule" v-model="picked" >
              <option v-for="option in options"
                      v-bind:key="option.id"
                      v-bind:value="option.id">
                {{option.name}}
              </option>
            </select>

          </b-col>
          <b-col sm="2">
            <label>
              {{ $t("bookingTransport.Schedule.tableSchedule.headings.typeTurno") }}
            </label>
            <br/>
            <select class="form-control mt-2" id ="statusSchedule" v-model="pickedTurnos" >
              <option v-for="option in optionsTurnos"
                      v-bind:key="option.id"
                      v-bind:value="option.id">
                {{option.name}}
              </option>
            </select>
          </b-col>
          <b-col>
            <label class="labelBold mt-2">{{ $t("bookingTransport.Schedule.tableSchedule.headings.shift_name") }}</label>
            <input type="text" v-model="EditSchedule" />

            <div v-if="$v.EditSchedule.$error" class="error-msg">
              <!-- <p v-if="!$v.dates.from.required">{{$t("bookingTransport.Stops.TableStops.headings.route_idrequired")}}</p> -->
              <p v-if="!$v.EditSchedule.required">{{$t("bookingTransport.Schedule.tableSchedule.headings.shift_name")}} {{$t("bookingTransport.required")}}</p>
            </div>

          </b-col>


        </b-row>
        <br/>
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col>
            <div class="dateInput">
              <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.start_date") }}</label>
              <br>
              <date-picker class="dateInput" v-model="dates.from" placeholder="YYYY-MM-DD" value-type="format" format="YYYY-MM-DD" >
              </date-picker>
              <div v-if="$v.dates.from.$error" class="error-msg">
                <!-- <p v-if="!$v.dates.from.required">{{$t("bookingTransport.Stops.TableStops.headings.route_idrequired")}}</p> -->
                <p v-if="!$v.dates.from.required">{{$t("bookingTransport.Schedule.tableSchedule.headings.start_date")}} {{$t("bookingTransport.required")}}</p>
              </div>

            </div>
          </b-col>
          <b-col>
            <div class="dateInput">
              <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.end_date") }}</label>
              <br>
              <date-picker class="dateInput" v-model="dates.to" placeholder="YYYY-MM-DD" value-type="format" format="YYYY-MM-DD" >
              </date-picker>
              <div v-if="$v.dates.to.$error" class="error-msg">
                <!-- <p v-if="!$v.dates.from.required">{{$t("bookingTransport.Stops.TableStops.headings.route_idrequired")}}</p> -->
                <p v-if="!$v.dates.to.required">{{$t("bookingTransport.Schedule.tableSchedule.headings.end_date")}} {{$t("bookingTransport.required")}}</p>
              </div>

            </div>
          </b-col>


          <b-col>
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.start_time") }}</label>
            <vue-timepicker v-model="timeFromApp"></vue-timepicker>
          </b-col>
          <b-col>
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.end_time") }}</label>
            <vue-timepicker v-model="timeToApp"></vue-timepicker>
          </b-col>


        </b-row>
      </b-container>


      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditConfirm()"
          >
            Guardar
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeEdit()"
          >
            Cancelar
          </b-button>

        </div>
      </template>
    </b-modal>

  </div>
</template>

<script>



import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import { required} from "vuelidate/lib/validators";

import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";

import API_SERVICE from "@/lib/api/Booking.js";
import store from '@/vuex/store';

import moment from "moment";

const api = new API_SERVICE();


import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();

export default {

  components: {
    store,
    DatePicker,
    VueTimepicker
  },

  data() {
    return {
      id:"",
      picked:false,
      pickedTurnos:"choose",
      timeFromApp: null,
      timeToApp: null,
      start_date_filter:"",
      end_date_filter:"",
      dates:
        {
          from: null,
          to: null,
        },

      Anden:"",
      edit: false,
      EditSchedule:"",
      filePlatform:null,
      filelocation:null,
      error:null,
      file:false,
      fileOk:false,

      nuevo:false,
      selected:"",


      car_plate:"",
      status:"",
      controlNumber:"",
      columns: [
        "id",
        "name",
        "action",],
      tableData: [
        {
          "id": 12168,
          "name": "Capu"

        },
        {
          "id": 11963,
          "name": "Las Animas"

        },
        {
          "id": 11352,
          "name": "Loreto"

        }
      ]
    };
  },
  validations: {

    EditSchedule:{
      required
    },

    dates: {
      from:{
        required,
      },
      to: {
        required
      }
    },


  },

  filters: {

    formatDateOnly: function(value, lang) {
      if (!value) return '';
      if (lang === 'es') {
        moment.locale("es-do");
      }
      else {
        moment.locale("en");
      }
      return moment(value).utc().format("YYYY-MM-DD");
    },

  },

  computed:{

    ScheduleTable: function() {
      return this.$refs.ScheduleTable;

    },
    appLang: function ()
    {
      return this.$store.getters["settings/currentLang"];
    },

    options(){
      return[
        {id:"choose",name: this.$t('bookingTransport.Schedule.tableSchedule.headings.choose')} ,
        {id:true,name: this.$t("bookingTransport.Schedule.tableSchedule.headings.true")} ,
        {id:false,name: this.$t("bookingTransport.Schedule.tableSchedule.headings.false")}
      ]},

    optionsTurnos(){
      return[
        {id:"choose",name: this.$t('bookingTransport.Schedule.tableSchedule.headings.choose')} ,
        {id:1,name: this.$t("bookingTransport.Schedule.tableSchedule.headings.Prod")} ,
        {id:2,name: this.$t("bookingTransport.Schedule.tableSchedule.headings.Cent")}
      ]},

    table_columns: function() {
      return [
        "id",
        "enabled",
        "shift_name",
        "start_date",
        "end_date",
        "start_time",
        "end_time",
        "actions"
      ];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `bookingTransport.Schedule.tableSchedule.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(column => column !== "actions" && column !== "start_time" && column !== "end_time");
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          resizableColumns: false,
          perPageValues: [25, 50, 100],
          perPage: 25,
          columnsClasses: {
            actions: "actions-column",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("bookingTransport.Schedule.tableSchedule.headings.column_toggler"),
            limit: this.$t("bookingTransport.Schedule.tableSchedule.headings.limit")

          },

          requestAdapter: function(data) {
            const queries = {};
            queries.action = "list"
            queries.pagination= {all:false,
              limit:data.limit,
              page:data.page
            };
            queries.filters = data.query;
            return queries;

          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {

              const resp = await api.getSchedule(data);
              this.$store.commit("global/SET_LOADING", false);
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg: `${error}`,
                show: true,
                type: "error"
              });
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.data,
              count: response.total
            };
          }
        }
      };
    },

    table_headingsCarga: function () {
      if (this.columns) {
        const headings = {};
        this.columns.forEach((column) => {
          headings[column] = this.$t(`bookingTransport.Platform.tablePlatform.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersCarga: function () {
      return this.columns.filter((column) => column !== "action");
    },
    table_optionsCarga: function () {
      return {
        columns: this.columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headingsCarga,
          filterable: this.table_filtersCarga,
          sortable: [],
          resizableColumns: false,// columnas fijas
          perPage: 25,
          perPageValues: [25, 50, 100],
          columnsClasses: {
            select: "select-column",
            id: "id-column",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler"),
            limit: this.$t("users.search.table.limit")
          },
        },
      };
    }
  },

  methods: {

    filterStatus: function( $event)
    {

      if($event != "choose"){
        let status = ""
        if ($event == true){
          status = "true"
        }
        else if($event == false){
          status = "false"
        }
        else if($event == null){
          status = ""
        }
        this.ScheduleTable.setFilter({"enabled":status});
      }
      else{

        this.ScheduleTable.setFilter({"enabled":""});

      }
    },

    filterDate: function($event)
    {

      var date =""
      if($event == null)
      {
        date = ""

      }
      else{
        date =$event

      }
      this.ScheduleTable.setFilter({"start_date":date});
    },

    filterDateEnd: function($event)
    {
      var date =""
      if($event == null)
      {
        date = ""

      }
      else{
        date =$event

      }
      this.ScheduleTable.setFilter({"end_date":date});
    },


    timeOk(schedule) {
      return schedule.slice(0, -3);
    },

    translateStatus (status) {
      if (status == true){
        status = this.$t("bookingTransport.Schedule.tableSchedule.headings.true")
      }
      else if(status == false){
        status = this.$t("bookingTransport.Schedule.tableSchedule.headings.false")
      }
      else if(status == null){
        status =  "-"
      }
      else {
        status
      }
      return status
    },

    updateTable: function() {
      this.ScheduleTable.refresh();
    },

    Upload: async function(){
      await this.uploadFile();
    },

    uploadFile: async function() {
      try {

        if(this.filelocation){
          this.$store.commit("global/SET_LOADING", true);

          //  console.log(fileResp);
          //  console.log(Bucket);
          //  console.log(Key);
          //  this.alert.status = 'loading';

          var json = {upload_type: "stops",
            url: this.filelocation}

          const resp = await api.uploadFile(json);

          if(resp.message == "Datos insertados correctamente."){
            this.filelocation = null;
            this.filePlatform = null;
            this.file = false;
            this.fileOk = false;
            document.getElementById("file-2").value = "";
            document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");

            this.$store.commit("global/SET_ALERT", {
              msg: this.$t("bookingTransport.success"),
              show: true,
              type: "success"
            });
          }
          else{
            this.$store.commit("global/SET_ALERT", {
              msg: resp,
              show: true,
              type: "error"
            });


          }
          this.updateTable();
          this.$store.commit("global/SET_LOADING", false);
        }
        // else
        // {
        //         this.$store.commit("global/SET_ALERT", {
        //          msg: this.$t("bookingTransport.noFile"),
        //          show: true,
        //          type: "error"
        //        });
        // }
        // await api.uploadUsers(Bucket, Key, userType);
        // this.backendError = '';
        // this.alert.status = 'success';
        // this.loadingFile = false;
        // this.file = null;
        // this.fileUrl = null;
        // this.$v.$reset();
        // this.$emit('updateTable');
      } catch (error) {

        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error.response.data.message,
          show: true,
          type: "error"
        });
        // if(error.response.data.hasOwnProperty('err')){

        //   console.log(error);
        //   // this.backendError = error.response.data.err.replace(': ', ':<br>').replace(/required.,/g, 'required.<br>');
        //   this.backendError = error.response.data.err.replace('.', ' ').replace(/required.,/g, 'required.</br>').replace("\n", "<br/>");
        //   this.$refs['my-info'].show();

        // }
        // this.alert.status = 'error';
        // this.loadingFile = false;
        throw error;
      }
    },


    Modify: function(id,enabled,shift_name,start_date,end_date,start_time,end_time,type){

      this.edit = true;
      this.id = id;
      this.picked = enabled;
      this.EditSchedule = shift_name;
      this.dates.from = start_date;
      this.dates.to = end_date;
      this.timeFromApp = start_time;
      this.timeToApp = end_time;
      this.pickedTurnos = type;
      this.$refs['my-edit'].show();

    },


    loadCSV: async function(e){

      try{

        this.$store.commit("global/SET_LOADING", true);

        this.filePlatform = e.target.files[0];
        document.getElementById('filecsv').textContent = e.target.files[0].name;
        const timestamp = Date.now();
        let Type = "Stops";
        const file = `Booking/${Type}/${timestamp}_${Type}.csv`;
        const fileResp = await s3.uploadFile(file, this.filePlatform);
        const {Location} = fileResp;
        this.filelocation = Location;
        this.file = true;

        var json = {upload_type: "stops",
          url: Location}

        const resp = await api.validate(json)

        this.$store.commit("global/SET_LOADING", false);

        if(resp.message == "Datos fueron validados correctamente."){

          this.fileOk = true;
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.Routes.ready"),
            show: true,
            type: "success"
          });

        }
        else{
          this.$refs['my-error'].show();
          const backendError = resp.errors.toString().replace(/,/g, '\n');
          // var backendError1 = backendError.toString().replace(/,/g, '\n');
          // alert(backendError.toString());
          //const backendError = error.response.data.err.replace('.', ' ').replace(/required.,/g, 'required.</br>').replace("\n", "<br/>");
          //this.error = resp.errors;
          // this.error = backendError.toString();
          this.error = backendError;
        }
      }
      catch(error)
      {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    showInf: function(){
      this.$refs['my-info'].show();
    },

    removeFile: function () {

      try{
        this.filelocation = null;
        this.filePlatform = null;
        this.file = false;
        this.fileOk = false;
        document.getElementById("file-2").value = "";
        document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");

        this.$store.commit("global/SET_ALERT", {
          msg: this.$t("bookingTransport.delete"),
          show: true,
          type: "error"
        });
      }
      catch(error){

        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });

      }
    },
    showModal() {
      this.edit = false;
      this.id="";
      this.picked=true;
      this.pickedTurnos ="choose";
      this.EditSchedule="";
      this.dates.from="";
      this.dates.to="";
      this.timeFromApp =null;
      //this.timeFromApp.mm ="00";
      this.timeToApp =null;
      //this.timeToApp.mm ="59";
      this.$refs['my-edit'].show();
    },
    closeEdit(){
      this.id="";
      this.picked=true;
      this.EditSchedule="";
      this.dates.from="";
      this.dates.to="";
      this.timeFromApp="";
      this.timeToApp="";
      this.$refs['my-edit'].hide();
    },


    EditConfirm: async function (){
      try
      {
        this.$v.$touch();
        if (this.$v.$error)return;

        this.$store.commit("global/SET_LOADING", true);

        if(this.dates.to < this.dates.from )
        {
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("mobilityOnDemand.rango")}`,
            show: true,
            type: "error"
          });
          return;

        }

        if(this.timeFromApp == null)
        {
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.Schedule.invalidHour")}`,
            show: true,
            type: "error"
          });
          return;
        }
        if(this.timeFromApp != null)
        {
          if(this.timeFromApp.HH == "" || this.timeFromApp.mm == "" ) {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.Schedule.invalidHour")}`,
              show: true,
              type: "error"
            });
            return;
          }
        }

        if(this.timeToApp == null)
        {
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.Schedule.invalidHour")}`,
            show: true,
            type: "error"
          });
          return;
        }
        if(this.timeToApp != null)
        {
          if(this.timeToApp.HH == "" || this.timeToApp.mm == "" ) {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.Schedule.invalidHour")}`,
              show: true,
              type: "error"
            });
            return;
          }
        }


        const queries = {};

        if(this.edit){

          if(this.timeFromApp == "")
          {

            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.Schedule.invalidHour")}`,
              show: true,
              type: "error"
            });
            return;

          }

          if(this.timeToApp == "")
          {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.Schedule.invalidHour")}`,
              show: true,
              type: "error"
            });
            return;
          }



          queries.action = "update"
          queries.query= {
            id:this.id,
            enabled:this.picked,
            shift_name:this.EditSchedule,
            start_date:this.dates.from,
            end_date:this.dates.to,
            start_time:this.timeFromApp,
            end_time:this.timeToApp,
            type:this.pickedTurnos
          };
        }
        else {


          if(this.timeFromApp == "")
          {

            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.Schedule.invalidHour")}`,
              show: true,
              type: "error"
            });
            return;

          }

          if(this.timeToApp == "")
          {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.Schedule.invalidHour")}`,
              show: true,
              type: "error"
            });
            return;
          }
          queries.action = "create"
          queries.query= {
            enabled:this.picked,
            shift_name:this.EditSchedule,
            start_date:this.dates.from,
            end_date:this.dates.to,
            start_time:this.timeFromApp.HH +":"+this.timeFromApp.mm,
            end_time:this.timeToApp.HH + ":"+this.timeToApp.mm,
            type:this.pickedTurnos
          };
        }

        // console.log(queries);
        const resp = await api.getSchedule(queries);
        //
        // console.log(resp);

        this.updateTable();
        this.$store.commit("global/SET_LOADING", false);



        if(resp.message == "Los datos fueron actualizados correctamente." ){
          this.$refs['my-edit'].hide();
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.Schedule.update"),
            show: true,
            type: "success"
          });

        }
        if( resp.message == "Los datos fueron creados correctamente."){
          this.$refs['my-edit'].hide();
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.Schedule.create"),
            show: true,
            type: "success"
          });

        }
        this.$v.$reset();
        //if(resp.message != "Los datos fueron actualizados correctamente." || resp.message != "Los datos fueron creados correctamente."){        }




      }
      catch(error){

        this.$refs['my-error'].show();
        const backendError = error.toString().replace(/,/g, '\n');
        this.error = backendError;
        // this.$store.commit("global/SET_LOADING", false);
        //this.$store.commit("global/SET_ALERT", {
        //   msg: error,
        //  show: true,
        // type: "error"
        // });

      }
    },
    DowloadLayout(){

      try{
        let anchor = document.createElement("a");
        anchor.href = "https://817467424320-amap-dbs-qa-app-files.s3.ca-central-1.amazonaws.com/Booking/Stops/Paradas_Layout.csv";
        anchor.target = "_blank";
        anchor.click();

        this.$refs['my-info'].hide();
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t("bookingTransport.dowloaded"),
          show: true,
          type: "success"});

      }
      catch(error){
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    }
  }


};
</script>
<style lang="scss">
#ScheduleTable .table-responsive {
  height:100%;
  overflow:scroll;
}
.VueTables__start_date-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
}
#start_date{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}
.VueTables__end_date-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
}
#end_date{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}
.VueTables__enabled-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
}
#enabled{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}

</style>

<style lang="scss" scoped>



#Schedule {
  background-color: $white;
  padding: 2rem 4rem;
}

.btn-confirm {
  margin-left: 1rem;
  padding:1rem 1rem;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
}
.container-input {
  text-align: center;
  background: #fff; //#b6b0b0;
  border-top: 0px solid #fff; //#000000;
  padding: 0px 0;
  border-radius: 6px;
  width: 90%;
  height: 90%;
  margin: 0 auto;
  margin-bottom: 1em;
}

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;

}

.inputfile + label {
  max-width: 100%;
  font-size: 1.35rem;
  font-weight: 200;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  padding: 0.625rem 1.25rem;
}

.inputfile + label i {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  margin-right: 0.45em;
}

.iborrainputfile {
  font-size:14px;
}

.inputfile-2 + label {
  color: #fff;
  background-color: #000000;
}

.inputfile-2:focus + label,
.inputfile-2.has-focus + label,
.inputfile-2 + label:hover {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #000000;
}

.error-msg {
  color: $warn_red;
  font-size: 14px;
}



</style>

